// extracted by mini-css-extract-plugin
export default {"categoryName":"CategorySelectorSingleCategory_categoryName__30mfP"};